"use strict";
/*
 * Created on 8. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ProductPrice_1 = require("../../product/model/ProductPrice");

var ProductPriceConverter_1 = require("./ProductPriceConverter");
/**
 * @author Radek Beran
 */


var ProductPriceConverterImpl =
/*#__PURE__*/
function (_ProductPriceConverte) {
  _inherits(ProductPriceConverterImpl, _ProductPriceConverte);

  function ProductPriceConverterImpl() {
    _classCallCheck(this, ProductPriceConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPriceConverterImpl).apply(this, arguments));
  }

  _createClass(ProductPriceConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductPrice_1.ProductPrice(!utils_1.Utils.isValueMissing(source.value) ? conversions.toBigNumber(source.value) : null, !utils_1.Utils.isValueMissing(source.vatId) ? conversions.toClassReferenceId(source.vatId) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        value: source.value !== null ? conversions.fromBigNumber(source.value) : null,
        vatId: source.vatId !== null ? conversions.toDocumentReferenceId(source.vatId) : null
      });
      return result;
    }
  }]);

  return ProductPriceConverterImpl;
}(ProductPriceConverter_1.ProductPriceConverter);

exports.ProductPriceConverterImpl = ProductPriceConverterImpl;